import React from "react"

import { ArrowButton, Asset, Link } from "components"

function ListItem({ categorySlug, slug, title, slogan, menuPhoto }) {
  const HREF = `/products/${categorySlug}/${slug}/`

  return (
    <li className="gap-8 space-y-4 col-span-full md:col-span-6 lg:grid lg:items-center lg:grid-cols-6">
      <div className="lg:w-auto lg:col-span-2 w-36">
        <Link href={HREF} className="block select-none aspect-w-1 aspect-h-1">
          {menuPhoto && (
            <Asset
              asset={menuPhoto}
              objectFit="cover"
              objectPosition="center"
              style={{ position: "absolute" }}
            />
          )}
        </Link>
      </div>
      <div className="space-y-4 lg:col-span-4">
        <ArrowButton label={title} href={HREF} className="h3" />
        <p className="body text-mineralGray">{slogan}</p>
      </div>
    </li>
  )
}

export default ListItem
